import { useQuery } from 'react-query';

import { QueryEntity } from '../types';
import type { LoadFileImportListItem } from './useGetLoadFileImports';
import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig from '@/api/useGetFetchConfig';

/** Fetches a single `.dat` import's summary (backs the wizard on deep-link/refresh). */
const useGetLoadFileImport = (
  matterId: string | undefined,
  importId: string | undefined,
  options: { enabled?: boolean; refetchInterval?: number | false } = {},
) => {
  const { enabled = true, refetchInterval = false } = options;
  const { fetchConfigGET } = useGetFetchConfig();

  const getLoadFileImport = async (): Promise<LoadFileImportListItem> => {
    const url = `${APIBaseChronos}/api/relativity/load-file-import/${importId}?matterId=${matterId}`;
    const response = await fetch(url, fetchConfigGET);

    if (!response.ok) {
      throw new Error(`Failed to fetch load file import: ${response.status} ${response.statusText}`);
    }

    return response.json();
  };

  return useQuery([QueryEntity.LoadFileImports, { matterId, importId }], getLoadFileImport, {
    enabled: enabled && !!matterId && !!importId,
    refetchOnWindowFocus: false,
    refetchInterval,
  });
};

export default useGetLoadFileImport;
